export default __webpack_public_path__ + "static/media/kpi.card.light.pattern.c17828c2.svg";